import baseRoute from '../baseRoute';

export default `${baseRoute}/timeCard` as const;
